
import CanvasJSReact_ReportYearly from '../chart/Chart_ReportYearly';

import {
    getErrText,
    getErrColor,
    createdata_row
} from "./library"

import './bee-print-yearly.css';

function SiteReportYearly({ reportdata, reportchart }) {

    return (
        <div className='report-wrapper'>
            <div className="page-horizontal rp-yearly">
                <div className="document-header">
                    <div className="document-logo-left">
                        <img src="/images/ReportLogoleft.bmp" className="logo" style={{ opacity: "1" }} alt='logo-left1' />
                    </div>
                    <div className="document-logo-right">
                        {/* <img src="/images/ReportLogoright.bmp" className="logo" style={{ opacity: "1" }} alt='logo-right1' /> */}
                        <div className="company-box">
                            SHINING SPV 1 CO., LTD.
                        </div>
                    </div>

                    <label className="document-type">Yearly Report</label>
                    <label className="document-date" id="data-yearly-header-reportdate1">{reportdata.Header?.ReportDate}</label>
                    <label className="document-sitelocation" id="data-yearly-header-sitename1">{reportdata.Header?.SiteName}</label>
                    <label className="document-pages">Pages 1/2</label>

                    <div className="document-capacity">
                        <div className="container">
                            <label>Capacity</label>
                            <span id="data-yearly-header-capacity1">{reportdata.Header?.Capacity}</span>
                            <span className="totalunit">kWp</span>
                        </div>
                    </div>

                    <div className="document-area">
                        <div className="container">
                            <label>Area</label>
                            <span id="data-yearly-header-area1">{reportdata.Header?.Area}</span>
                            <span className="totalunit">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                <div className="document-info">
                    <div className="document-info1">
                        <div className="container">
                            <label>Energy from Solar {reportdata.Header?.SolarType}</label>
                            <span className='font-sarabun' id="data-yearly-info-energysolar1">{reportdata.Info?.EnergySolar}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, On-Peak</label>
                            <span className='font-sarabun ' id="data-yearly-info-energysolar-onpeak1">{reportdata.Info?.EnergySolar_OnPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, Off-Peak</label>
                            <span className='font-sarabun ' id="data-yearly-info-energysolar-offpeak1">{reportdata.Info?.EnergySolar_OffPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                    </div>
                    <div className="document-info2">
                        <div className="container">
                            <label>Energy not Supply (ENS)</label>
                            <span className='font-sarabun' id="data-yearly-info-ens1" >{reportdata.Info?.ENS}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>CO<sub>2</sub> Reduction</label>
                            <span className='font-sarabun' id="data-yearly-info-co21">{reportdata.Info?.CO2}</span>
                            <span className="totalunit">kgCO<sub>2</sub></span>
                        </div>
                    </div>
                    <div className="document-info3">
                        <div className="container">
                            <label>PR</label>
                            <span id="data-yearly-info-prens1" className={'font-sarabun ' + getErrColor(reportdata.FlagPR)}>{getErrText(reportdata.FlagPR, reportdata.Info?.PR_ENS)}</span>
                            <span className="totalunit">%</span>
                        </div>
                        <div className="container">
                            <label>OR</label>
                            <span id="data-yearly-info-or1" className={'font-sarabun ' + getErrColor(reportdata.FlagSumOR)}>{reportdata.Info?.ORX_ENS}</span>
                            <span className="totalunit">%</span>
                        </div>
                    </div>

                    <div className="document-info4">
                        <div className="container">
                            <label>Irradiance</label>
                            <span className='font-sarabun' id="data-yearly-info-irr1">{reportdata.Info?.IRR}</span>
                            <span className="totalunit">kWh/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Irradiance (max)</label>
                            <span className='font-sarabun' id="data-yearly-info-irrmax1" >{reportdata.Info?.IRRMax}</span>
                            <span className="totalunit">W/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Module Temp (max)</label>
                            <span className='font-sarabun' id="data-yearly-info-tempmax1" >{reportdata.Info?.ModuleTempMax}</span>
                            <span className="totalunit">°C</span>
                        </div>
                    </div>
                </div>

                <div className="itemtable">
                    <table className="tablex table-hover table-yearly" id="table-yearly-report">
                        <thead className="table-header">
                            <tr className="r1">
                                <th className="horizinton-align-center bottom-black-line" id="cDateY">Month</th>
                                <th className="horizinton-align-center bottom-black-line">Irradiance <p>(kWh/m<sup>2</sup>)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Solar Energy <p>(For CAL)</p>
                                    <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Solar Energy <p>(Billing)</p>
                                    <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Acc. <p>Solar Energy</p>
                                    <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Est. Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">ENS <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Diff. Energy <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">CO<sub>2</sub> Reduction <p>
                                    (kgCO<sub>2</sub>)
                                </p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">PR <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">OR <p>(%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Solar <p>Avai (%)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Energy Grid <p>(kWh)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Est. Value <p>(Baht)</p>
                                </th>
                                <th className="horizinton-align-center bottom-black-line">Est. Saving <p>(Baht)</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody >
                            {
                                reportdata.TableData?.map((data, index) => (
                                    <tr key={"data-yearly-D" + index} className="">
                                        <td align="center" className="item col-rx-black">{data.Datex}</td>
                                        {createdata_row("", data.IRR, data.CODStatus)}
                                        {createdata_row("", data.EnergyAC_Cal, data.CODStatus)}
                                        {createdata_row("", data.EnergyAC_Bill, data.CODStatus)}
                                        {createdata_row("", data.EnergyAC_ACC, data.CODStatus)}
                                        {createdata_row("", data.EST_Energy, data.CODStatus)}
                                        {createdata_row("", data.ENS, data.CODStatus)}
                                        {createdata_row("", data.Diff_Energy, data.CODStatus)}
                                        {createdata_row("", data.CO2, data.CODStatus)}
                                        {createdata_row(data.FlagPR, data.PR_ENS, data.CODStatus)}
                                        {createdata_row(data.FlagOR, data.ORX_ENS, data.CODStatus)}
                                        {createdata_row("", data.AVI, data.CODStatus)}
                                        {createdata_row("", data.EnergyGrid, data.CODStatus)}
                                        {createdata_row("", data.EST_Value, data.CODStatus)}
                                        {createdata_row("", data.EST_Saving, data.CODStatus)}
                                    </tr>
                                ))
                            }
                            <tr className="summary" id="data-yearly-summary1">
                                <td align="center" className="item col-rx-black">Total</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.TotalIRR}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.TotalEnergyAC_Cal}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.TotalEST_Energy}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.TotalENS}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.TotalDiff_Energy}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className={"item " + getErrColor(reportdata.FlagTotalOR)}>{reportdata.Summary?.TotalORX}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                            </tr>
                            <tr className="summary1" id="data-yearly-summary2">
                                <td align="center" className="item col-rx-black" rowSpan="2">Summary</td>
                                <td align="right" className="item col-rx-black" rowSpan="2">{reportdata.Summary?.sumIRR}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black" rowSpan="2">{reportdata.Summary?.sumEnergyAC_Bill}</td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black" rowSpan="2">{reportdata.Summary?.sumEST_Energy}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.sumENS1}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.sumDiff_Energy1}</td>
                                <td align="right" className="item col-rx-black" rowSpan="2">{reportdata.Summary?.sumCO2}</td>
                                <td align="right" className={"item " + getErrColor(reportdata.FlagPR)} rowSpan="2">{getErrText(reportdata.FlagPR, reportdata.Summary?.sumPR_ENS)}</td>
                                <td align="right" className={"item " + getErrColor(reportdata.FlagSumOR)} rowSpan="2">{reportdata.Summary?.sumORX}</td>
                                <td align="right" className="item col-rx-black" rowSpan="2">{reportdata.Summary?.sumAVI}</td>
                                <td align="right" className="item col-rx-black" rowSpan="2">{reportdata.Summary?.sumEnergyGrid}</td>
                                <td align="right" className="item col-rx-black" rowSpan="2">{reportdata.Summary?.sumEST_Value}</td>
                                <td align="right" className="item col-rx-black" rowSpan="2">{reportdata.Summary?.sumEST_Saving}</td>
                            </tr>
                            <tr className="summary1" id="data-yearly-summary3">
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black total-disable"></td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.sumENS2}</td>
                                <td align="right" className="item col-rx-black">{reportdata.Summary?.sumDiff_Energy2}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <label className="refference-remark">Remark</label>
                <div className="refference-remark1">
                    <div className="container">
                        <label>PR<sub>G</sub></label>
                        <span className='font-sarabun' id="data-yearly-ref-prg">{reportdata.Refference?.PRG}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>OR<sub>G</sub></label>
                        <span className='font-sarabun' id="data-yearly-ref-org">{reportdata.Refference?.ORG}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>@#Yr.</label>
                        <span className='font-sarabun' id="data-yearly-ref-year">{reportdata.Refference?.YR}</span>
                        <span className="totalunit"></span>
                    </div>
                </div>

                <div className="refference-remark2">
                    <div className="container">
                        <label>STC </label>
                        <span className='font-sarabun' id="data-yearly-ref-stc">{reportdata.Refference?.STC}</span>
                        <span className="totalunit">%</span>
                    </div>
                    <div className="container">
                        <label>1kWh = </label>
                        <span className='font-sarabun' id="data-yearly-ref-co2">{reportdata.Refference?.Factor_CO2}</span>
                        <span className="totalunit">kgCO<sub>2</sub></span>
                    </div>
                    <div className="container">
                        <label className='font-sarabun'>จำนวนวันที่แสงผิดปกติทั้งปี</label>
                        <span className='font-sarabun' id="data-yearly-ref-irrerr">{reportdata.Refference?.IRRErr}</span>
                        <span className="totalunit">วัน</span>
                    </div>
                    <div className="container">
                        <label className='font-sarabun'>จำนวนวันที่หยุดรับซื้อไฟฟ้า</label>
                        <span className='font-sarabun' id="data-yearly-ref-nonepurchase">{reportdata.Refference?.PurchaseDay}</span>
                        <span className="totalunit">วัน</span>
                    </div>
                    <div className="container">
                        <label className='font-sarabun'>จำนวนวันที่หยุดรับซื้อไฟฟ้า(อนุญาต)</label>
                        <span className='font-sarabun' id="data-yearly-ref-nonepurchase-approve">{reportdata.Refference?.PurchaseDayApprove}</span>
                        <span className="totalunit">วัน</span>
                    </div>
                </div>
                <div className="rate-header font-sarabun">ตารางอ้างอิง Unit Rate และค่า FT</div>
                <div className="rate-table font-sarabun">
                    <div className="rate-row font-sarabun">
                        <div className="rate-cell font-sarabun line-bottom">เดือน</div>
                        <div className="rate-cell font-sarabun line-bottom">On-Peak</div>
                        <div className="rate-cell font-sarabun line-bottom">Off-Peak</div>
                        <div className="rate-cell font-sarabun line-bottom">FT</div>
                        <div className="rate-cell font-sarabun line-bottom">เดือน</div>
                        <div className="rate-cell font-sarabun line-bottom">On-Peak</div>
                        <div className="rate-cell font-sarabun line-bottom">Off-Peak</div>
                        <div className="rate-cell font-sarabun line-bottom">FT</div>
                    </div>
                    {
                        reportdata.Refference?.Rate_Price ?
                            reportdata.Refference?.Rate_Price?.map((data, index) => (
                                index < 6 ?
                                    <div className="rate-row font-sarabun" key={index}>
                                        <div className="rate-cell font-sarabun line-bottom">{data.Month}</div>
                                        <div className="rate-cell font-sarabun line-bottom">{data.UnitRate_OnPeak}</div>
                                        <div className="rate-cell font-sarabun line-bottom">{data.UnitRate_OffPeak}</div>
                                        <div className="rate-cell font-sarabun line-bottom">{data.FT}</div>
                                        <div className="rate-cell font-sarabun line-bottom">{reportdata.Refference?.Rate_Price[index + 6]?.Month}</div>
                                        <div className="rate-cell font-sarabun line-bottom">{reportdata.Refference?.Rate_Price[index + 6]?.UnitRate_OnPeak}</div>
                                        <div className="rate-cell font-sarabun line-bottom">{reportdata.Refference?.Rate_Price[index + 6]?.UnitRate_OffPeak}</div>
                                        <div className="rate-cell font-sarabun line-bottom">{reportdata.Refference?.Rate_Price[index + 6]?.FT}</div>
                                    </div>
                                    :
                                    null
                            ))
                            : null
                    }
                </div>

                {/* <div className="buyrate-table font-sarabun">
                            <div className="buyrate-cell-cap">ราคาซื้อไฟต่อหน่วยในแต่ละเดือน</div>
                            <div className="buyrate-row">
                                <div className="buyrate-cell px-2">1 - 3</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[0]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[0] : ""}</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[1]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[1] : ""}</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[2]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[2] : ""}</div>
                                <div className="buyrate-cell px-1">Baht/kWh</div>
                            </div>
                            <div className="buyrate-row">
                                <div className="buyrate-cell px-2">4 - 6</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[3]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[3] : ""}</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[4]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[4] : ""}</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[5]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[5] : ""}</div>
                                <div className="buyrate-cell px-1">Baht/kWh</div>
                            </div>
                            <div className="buyrate-row">
                                <div className="buyrate-cell px-2">7 - 9</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[6]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[6] : ""}</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[7]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[7] : ""}</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[8]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[8] : ""}</div>
                                <div className="buyrate-cell px-1">Baht/kWh</div>
                            </div>
                            <div className="buyrate-row">
                                <div className="buyrate-cell px-2">10 - 12</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[9]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[9] : ""}</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[10]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[10] : ""}</div>
                                <div className={"buyrate-cell align-right " + buyrate_cod[11]}>{reportdata.Refference.BuyRate_Price ? reportdata.Refference.BuyRate_Price[11] : ""}</div>
                                <div className="buyrate-cell px-1">Baht/kWh</div>
                            </div>
                        </div> */}
                <div className="doc-remark">
                    <label className="generate-remark1" id="generate-daily-print1">Printed Date : {reportdata.Header?.PrintDate}</label>
                    <label className="generate-remark2">* This reports have been generated by CPF solar monitoring system local web
                        application. *</label>
                </div>
            </div>

            <div className="page-horizontal rp-yearly mt-2">
                <div className="document-header">
                    <div className="document-logo-left">
                        <img src="/images/ReportLogoleft.bmp" className="logo" style={{ opacity: "1" }} alt='logo-left2' />
                    </div>
                    <div className="document-logo-right">
                        {/* <img src="/images/ReportLogoright.bmp" className="logo" style={{ opacity: "1" }} alt='logo-right2' /> */}
                        <div className="company-box">
                            SHINING SPV 1 CO., LTD.
                        </div>
                    </div>

                    <label className="document-type">Yearly Report</label>
                    <label className="document-date" id="data-yearly-header-reportdate2">{reportdata.Header?.ReportDate}</label>
                    <label className="document-sitelocation" id="data-yearly-header-sitename2">{reportdata.Header?.SiteName}</label>
                    <label className="document-pages">Pages 2/2</label>

                    <div className="document-capacity">
                        <div className="container">
                            <label>Capacity</label>
                            <span className='font-sarabun' id="data-yearly-header-capacity2">{reportdata.Header?.Capacity}</span>
                            <span className="totalunit">kWp</span>
                        </div>
                    </div>

                    <div className="document-area">
                        <div className="container">
                            <label>Area</label>
                            <span className='font-sarabun' id="data-yearly-header-area2">{reportdata.Header?.Area}</span>
                            <span className="totalunit">m<sup>2</sup></span>
                        </div>
                    </div>
                </div>

                <div className="document-info">
                    <div className="document-info1">
                        <div className="container">
                            <label>Energy from Solar {reportdata.Header?.SolarType}</label>
                            <span className='font-sarabun' id="data-yearly-info-energysolar2">{reportdata.Info?.EnergySolar}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, On-Peak</label>
                            <span className='font-sarabun ' id="data-yearly-info-energysolar-onpeak2">{reportdata.Info?.EnergySolar_OnPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>Energy from Solar, Off-Peak</label>
                            <span className='font-sarabun ' id="data-yearly-info-energysolar-offpeak2">{reportdata.Info?.EnergySolar_OffPeak}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                    </div>
                    <div className="document-info2">
                        <div className="container">
                            <label>Energy not Supply (ENS)</label>
                            <span className='font-sarabun' id="data-yearly-info-ens2" >{reportdata.Info?.ENS}</span>
                            <span className="totalunit">kWh</span>
                        </div>
                        <div className="container">
                            <label>CO<sub>2</sub> Reduction</label>
                            <span className='font-sarabun' id="data-yearly-info-co22">{reportdata.Info?.CO2}</span>
                            <span className="totalunit">kgCO<sub>2</sub></span>
                        </div>
                    </div>
                    <div className="document-info3">
                        <div className="container">
                            <label>PR</label>
                            <span id="data-yearly-info-prens2" className={'font-sarabun ' + getErrColor(reportdata.FlagPR)}>{getErrText(reportdata.FlagPR, reportdata.Info?.PR_ENS)}</span>
                            <span className="totalunit">%</span>
                        </div>
                        <div className="container">
                            <label>OR</label>
                            <span id="data-yearly-info-or2" className={'font-sarabun ' + getErrColor(reportdata.FlagSumOR)}>{reportdata.Info?.ORX_ENS}</span>
                            <span className="totalunit">%</span>
                        </div>
                    </div>

                    <div className="document-info4">
                        <div className="container">
                            <label>Irradiance</label>
                            <span className='font-sarabun' id="data-yearly-info-irr2" >{reportdata.Info?.IRR}</span>
                            <span className="totalunit">kWh/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Irradiance (max)</label>
                            <span className='font-sarabun' id="data-yearly-info-irrmax2" >{reportdata.Info?.IRRMax}</span>
                            <span className="totalunit">W/m<sup>2</sup></span>
                        </div>
                        <div className="container">
                            <label>Module Temp (max)</label>
                            <span className='font-sarabun' id="data-yearly-info-tempmax2" >{reportdata.Info?.ModuleTempMax}</span>
                            <span className="totalunit">°C</span>
                        </div>
                    </div>
                </div>

                <div className="chart-yearly-wrapper">
                    <div className="chx" id="trend-yearly" style={{ height: "545px", width: "100%" }}>
                        <CanvasJSReact_ReportYearly
                            info={reportdata.Header}
                            xlabel={reportchart.XLabel}
                            solorpower={reportchart.EnergyAC}
                            estimatepower={reportchart.EnergyEST}
                            ens={reportchart.ENS}
                        ></CanvasJSReact_ReportYearly>
                    </div>
                </div>

                <div className="doc-remark">
                    <label className="generate-remark1" id="generate-daily-print1">Printed Date : {reportdata.Header?.PrintDate}</label>
                    <label className="generate-remark2">* This reports have been generated by CPF solar monitoring system local web
                        application. *</label>
                </div>
            </div>
        </div>
    )
}
export default SiteReportYearly